(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.customer.show.project.bulkStateChange', {
      url: '/bulk-state-change',
      template: `<new-front-container path="'bulk-assets-config'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.BulkStateChange" | translate}}',
      },
    });
  }
})();
